import { createPortal } from 'react-dom'
import TelephoneInput from './TelephoneInput'
import { useTheme } from '../../theme'

// Couleurs officielles Manrina
const MANRINA_COLORS = {
  orange: 'rgb(var(--c-primary))',
  vert: 'rgb(var(--c-green))',
  creme: 'rgb(var(--c-creme))',
}

// Modal de reinitialisation du PIN
// TelephoneInput attend le meme jeu de classes que les ecrans d'auth ; ce modal
// composait les siennes a la main. On les regroupe ici pour ne pas dupliquer la
// forme du champ (une seule regle de saisie de telephone — cf. DESIGN-GUIDE).
function classesChamps(isWeb3) {
  return {
    inputBg: isWeb3 ? 'bg-white/5' : 'bg-creme',
    inputBorder: isWeb3 ? 'border-white/20' : 'border-ink/10',
    inputText: isWeb3 ? 'text-white placeholder-white/30' : 'text-ink placeholder-ink/30',
    textSecondary: isWeb3 ? 'text-white/70' : 'text-ink/70',
    textMuted: isWeb3 ? 'text-white/45' : 'text-ink/45',
  }
}

export default function PinForgotModal({
  showPinForgot,
  setShowPinForgot,
  pinForgotPhone,
  setPinForgotPhone,
  pinForgotLoading,
  pinForgotMessage,
  pinForgotError,
  handlePinForgot,
}) {
  const { isWeb3 } = useTheme()
  if (!showPinForgot) return null
  const tChamps = classesChamps(isWeb3)

  return createPortal(
    <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 p-4 backdrop-blur-sm">
      <div className={`${isWeb3 ? 'bg-[#0a0a0f]/95' : 'bg-white'} rounded-2xl p-6 w-full max-w-md shadow-xl border border-ink/10`}>
        <h3 className={`text-lg font-bold text-ink mb-2`}>
          Réinitialisation du PIN
        </h3>
        <p className={`text-sm text-ink/60 mb-5`}>
          Entrez votre numéro de téléphone pour faire une demande de réinitialisation. Un administrateur vous contactera.
        </p>

        <div className="mb-4">
          <TelephoneInput
            id="pin-forgot-tel"
            label="Numéro de téléphone"
            value={pinForgotPhone}
            onChange={setPinForgotPhone}
            t={tChamps}
            disabled={pinForgotLoading}
            autoFocus
          />
        </div>

        {pinForgotError && (
          <div className={`p-3 rounded-xl mb-4 text-sm ${isWeb3 ? 'bg-red-500/20 text-red-300' : 'bg-red-50 text-red-600'}`}>
            {pinForgotError}
          </div>
        )}

        {pinForgotMessage && (
          <div className={`p-3 rounded-xl mb-4 text-sm ${isWeb3 ? 'bg-green-500/20 text-green-300' : 'bg-green-50 text-green-600'}`}>
            <div className="flex items-start gap-2">
              <svg className="w-5 h-5 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
              {pinForgotMessage}
            </div>
          </div>
        )}

        <div className="flex gap-3">
          <button
            onClick={() => setShowPinForgot(false)}
            className={`flex-1 py-3 rounded-xl font-medium text-sm transition ${
              isWeb3
                ? 'bg-white/5 border border-white/10 text-white hover:bg-white/10'
                : 'bg-ink/5 text-ink hover:bg-ink/10'
            }`}
          >
            Fermer
          </button>
          {!pinForgotMessage && (
            <button
              onClick={handlePinForgot}
              disabled={pinForgotLoading || !pinForgotPhone || pinForgotPhone.length < 10}
              className="flex-1 py-3 rounded-xl text-white font-semibold text-sm hover:opacity-90 disabled:opacity-50 transition flex items-center justify-center gap-2"
              style={{ background: `linear-gradient(135deg, ${MANRINA_COLORS.orange}, ${MANRINA_COLORS.vert})` }}
            >
              {pinForgotLoading ? (
                <span className="inline-block w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin" />
              ) : (
                'Envoyer la demande'
              )}
            </button>
          )}
        </div>
      </div>
    </div>,
    document.body
  )
}
